import { type FC } from 'react';
import { IconAlertCircle } from '@tabler/icons-react';
import { Alert } from '@mantine/core';

export const BindingAlert: FC = () => {
    return (
        <Alert
            radius='lg'
            w='100%'
            variant='light'
            color='yellow'
            title='Функционал недоступен'
            icon={<IconAlertCircle size={16} />}
        >
            Для создания приемного ордера понадобится привязка к ордеру на бирже. Воспользуйтесь расширением.
        </Alert>
    );
};
